module.exports = __webpack_public_path__ + "static/media/icon_hazard_blue.df20ef4c.svg";